import { publicApi } from '../api';

export const API_PUBLIC_CHANNEL_PATH = '/public/channel';

export const fetchOneChannelByHashtag = (hashtag) => publicApi.get(`${API_PUBLIC_CHANNEL_PATH}/byhashtag/${hashtag}`);
